import MessageIcon from "../assets/icons/message.png";
import TeamworkIcon from "../assets/icons/teamwork.png";
import AnalyticsIcon from "../assets/icons/analytics.png";
import ProfileUserIcon from "../assets/icons/profile-user.png";
import FilterIcon from "../assets/icons/filter.png";
import ChecklistIcon from "../assets/icons/checklist.png";
import Post1Image from "../assets/img/post-1.png";
import Post2Image from "../assets/img/post-2.png";
import Post3Image from "../assets/img/post-3.png";
import FacebookIcon from "../assets/icons/facebook.png";
import InstagramIcon from "../assets/icons/instagram.png";
import LinkedinIcon from "../assets/icons/linkedin.png";
import TikTokIcon from "../assets/icons/tik-tok.png";
import YoutubeIcon from "../assets/icons/youtube.png";
import GestionLogo from "../assets/logos/gestion.png";
import CaretasLogo from "../assets/logos/caretas.png";
import PqsLogo from "../assets/logos/pqs.png";
import AndinaLogo from "../assets/logos/andina.png";
import DiegoPhoto from "../assets/img/diego-montes.png";
import DeyviPhoto from "../assets/img/deyvi-conde.png";
import RenzoPhoto from "../assets/img/renzo-trujillo.png";
import IabLogo from "../assets/logos/iab-gray.png";
import SeedspaceLogo from "../assets/logos/seedspace-gray.png";
import MultiverseLogo from "../assets/logos/multiverse.png";
import StartupLinksLogo from "../assets/logos/startuplinks.png";
import SpotifyPodcast from "../assets/img/spotify-podcast.png";
import ApplePodcast from "../assets/img/apple-podcast.png";
import GooglePodcast from "../assets/img/google-podcast.png";
import { ReactComponent as BuildingIcon } from "../assets/icons/building-solid.svg";
import { ReactComponent as AgentIcon } from "../assets/icons/call-center-worker.svg";
import { ReactComponent as ProfessionalIcon } from "../assets/icons/building.svg";
import { ReactComponent as EnterpriseIcon } from "../assets/icons/building2.svg";
import { ReactComponent as StandardIcon } from "../assets/icons/rocket.svg";
import {
  post1Tramy,
  post2Tramy,
  post3Tramy,
  gestionNews,
  pqsNews,
  caretasNews,
  andinaNews,
  video1Tramy,
  video2Tramy,
  video3Tramy,
  video4Tramy,
  tramyPodcast,
} from "../constants/urls";

// Footer Section

export const socialMediaArray = [
  {
    link: "https://www.facebook.com/tramy.crm",
    image: FacebookIcon,
  },
  {
    link: "https://www.instagram.com/tramy.io/?hl=es",
    image: InstagramIcon,
  },
  {
    link: "https://www.linkedin.com/company/tramy-io/",
    image: LinkedinIcon,
  },
  {
    link: "https://www.youtube.com/channel/UCUGFneNc6FuE6U-Z7UONKFQ",
    image: YoutubeIcon,
  },
  {
    link: "https://www.tiktok.com/@tramy.io",
    image: TikTokIcon,
  },
];

// Welcome Section
export const titleWelcome =
  "El aliado ideal para los equipos que atienden y venden por Whatsapp";

export const subtitleWelcome =
  "Tramy centraliza y automatiza tu proceso comercial realizando un mejor seguimiento de prospectos.";

// Press Section
export const pressArray = [
  { link: gestionNews, image: GestionLogo },
  { link: pqsNews, image: PqsLogo },
  { link: caretasNews, image: CaretasLogo },
  { link: andinaNews, image: AndinaLogo },
];

// Plans Section
export const descriptionArray1 = [
  "💬  1 línea de Whatsapp API ($35 por cada línea adicional)",
  "🧑 💻  3 usuarios ($15 por cada usuario adicional)",
];

export const descriptionArray2 = [
  "💬  1 línea de Whatsapp API ($35 por cada línea adicional)",
  "🧑 💻  5 usuarios ($15 por cada usuario adicional)",
];
export const descriptionArray3 = [
  "+50 USUARIOS",
  "*Si tienes un equipo grande, ponte en contacto con nuestros especialistas.",
];

export const featuresArray1 = [
  "Panel de administración de usuarios",
  "Embudo de ventas para WhatsApp",
  "CRM para WhatsApp",
  "Multiagente para WhatsApp",
  "Soporte premium",
  "Hasta 1,000 contactos",
];
export const featuresArray2 = [
  "Todas las funciones de PLAN STANDARD",
  "Plan personalizado",
  "Atención preferencial",
  "Acceso anticipado de actualizaciones",
  "Hasta 3,000 contactos",
];

export const featuresArray3 = [
  "Todas las funciones de PLAN PROFESSIONAL",
  "Plan personalizado",
  "Atención preferencial",
];

// Usage Section
export const usageArray = [
  {
    icon: MessageIcon,
    title: "1.Clientes envían consultas",
    description:
      "Tu cliente escribe al número único de WhatsApp de tu negocio. Tu equipo de atención al cliente es notificado al instante.",
  },
  {
    icon: TeamworkIcon,
    title: "2. Recibe, responde y gestiona",
    description:
      "El mensaje llega a la plataforma multiagente y es asignado a un agente de atención al cliente.",
  },
  {
    icon: AnalyticsIcon,
    title: "3. Supervisa y analiza",
    description:
      "El usuario administrador tiene acceso al panel y almacenamiento de todos los chats registrados con clientes.",
  },
];

// Features Section

export const featuresArray = [
  {
    icon: ChecklistIcon,
    title: "Orden",
    description:
      "Tu cliente escribe al número único de WhatsApp de tu negocio. Tu equipo de atención al cliente es notificado al instante.",
  },
  {
    icon: ProfileUserIcon,
    title: "Perfil del cliente",
    description:
      "Clasifica tus conversaciones y enfócate en las oportunidades de venta.",
  },
  {
    icon: FilterIcon,
    title: "Embudo de ventas",
    description: "Define los pasos de venta que se adapten a tu empresa.",
  },
];

// Analytics Section

export const analyticsArray = [
  { title: "3.5 B", subtitle: "Usuarios Activos" },
  {
    title: "84%",
    subtitle: "Del tiempo en móviles, se usa en aplicaciones de mensajería",
  },
  {
    title: "20 B",
    subtitle:
      "Mensajes enviados entre empresas y clientes (crecimiento de 4x anual)",
  },
];

// Team Section
export const teamArray = [
  {
    image: DiegoPhoto,
    name: "Diego Montes",
    link: "https://www.linkedin.com/in/diegomontesbarrenechea/",
    role: "CEO",
  },
  {
    image: DeyviPhoto,
    name: "Deyvi Conde",
    link: "https://www.linkedin.com/in/deyviconde/",
    role: "CTO",
  },
  {
    image: RenzoPhoto,
    name: "Renzo Trujillo",
    link: "https://www.linkedin.com/in/renzotrujillo/",
    role: "CMO",
  },
];

// Plans Section

export const plansArray = [
  {
    icon: <StandardIcon />,
    title: "STANDARD",
    previousPricing: "USD $79.00 / mes",
    currentPricing: "USD $59.00 / mes",
    description: descriptionArray1,
    features: featuresArray1,
  },
  {
    icon: <ProfessionalIcon />,
    borderColor: "5px solid #109cf1",
    title: "PROFESSIONAL",
    titleColor: "#109cf1",
    currentPricing: "USD $99.00 / mes",
    description: descriptionArray2,
    features: featuresArray2,
  },
  {
    icon: <EnterpriseIcon />,
    title: "ENTERPRISE",
    currentPricing: "PERSONALIZADO",
    description: descriptionArray3,
    features: featuresArray3,
  },
];

// Blog Section

export const blogArray = [
  {
    image: Post1Image,
    title: "¿Qué es el comercio conversacional?",
    description: "El ecommerce de los mercados emergentes.",
    link: post1Tramy,
  },
  {
    image: Post2Image,
    title: "¿Cómo integrar la API de WhatsApp a tu negocio?",
    description:
      "La API de WhatsApp es la mejor opción para escalar tu operación comercial",
    link: post2Tramy,
  },
  {
    image: Post3Image,
    title: "Razones para apostar por el comercio conversacional",
    description: "WhatsApp nos acerca por fin al comercio conversacional",
    link: post3Tramy,
  },
];

// ProductQuestions Sections

export const productQuestionsArray = [
  "¿Tu equipo demora en responder a potenciales clientes?",
  "¿Llegan cientos de chats diarios y no sabes cómo gestionarlos?",
  "¿En ocasiones dejas mensajes sin responder?",
  "¿Tus clientes cancelan compras por falta de atención?",
  "¿No sabes cómo supervisar si tu equipo atendió correctamente a tus clientes?",
];

// Whatsapp Pricing Section
export const tableHeaders = [
  "País",
  "Conversación iniciada por tu compañía (USD)",
  "Duración de conversación sin costo",
];

export const tableArray = [
  {
    country: "Perú 🇵🇪",
    price: "0.052 USD",
    duration: "24 HORAS",
  },
  {
    country: "México 🇲🇽",
    price: "0.040 USD",
    duration: "24 HORAS",
  },
  {
    country: "Brasil 🇧🇷",
    price: "0.064 USD",
    duration: "24 HORAS",
  },
  {
    country: "Colombia 🇨🇴",
    price: "0.020 USD",
    duration: "24 HORAS",
  },
  {
    country: "Ecuador 🇪🇨",
    price: "0.056 USD",
    duration: "24 HORAS",
  },
  {
    country: "España 🇪🇸",
    price: "0.054 USD",
    duration: "24 HORAS",
  },
  {
    country: "USA 🇺🇸",
    price: "0.040 USD",
    duration: "24 HORAS",
  },
];

// Alliances Section
export const alliancesArray = [
  { logo: IabLogo },
  { logo: SeedspaceLogo },
  { logo: MultiverseLogo },
  { logo: StartupLinksLogo },
];

// Alliances-Types Section
export const alliancesTypesArray = [
  {
    icon: <AgentIcon />,
    title: "Aliados Comerciales",
    audience: "Agentes de ventas y/o resellers.",
    description:
      "Recomienda nuestros servicios a tus seguidores, conocidos o audiencia y amplía tu fuente de ingresos.",
  },
  {
    icon: <BuildingIcon />,
    title: "Aliados Estratégicos",
    audience:
      "Agencias, outsourcers y/o comunidades con audiencias exponenciales.",
    description:
      "Incrementa tu catálogo de servicios, promoviendo nuestra plataforma dentro de tu comunidad.",
  },
];

// Alliances-Info Section
export const alliancesIntro =
  "Únete a nuestro programa de aliados y accede a beneficios exclusivos como:";

export const alliancesBenefits = [
  "Descuentos en nuestros planes.",
  "Entrenamiento en marketing y ventas.",
  "Acceso a biblioteca de recursos de marketing y ventas.",
];

// Alliances-Form Section
export const mailtoAlliances =
  "mailto:soporte@tramy.io?subject=¡Quiero ser un aliado de Tramy!";
export const responseTime =
  "Después de enviar tu solicitud, nos contactaremos contigo en un plazo máximo de 24 horas.";

export const inputsArray = [
  { name: "fullname", label: "Nombres y Apellidos", type: "text" },
  {
    name: "email",
    label: "Correo electrónico",
    type: "text",
  },
  { name: "phone", label: "Teléfono o celular de contacto", type: "number" },
];

export const optionsArray = [
  { value: "Aliado Comercial" },
  { value: "Aliado Estratégico" },
];

export const placeholderMessage =
  "Hola, deseo convertirme en un aliado de Tramy...";

// Youtube Channel Section

export const videosArray = [video1Tramy, video2Tramy, video3Tramy, video4Tramy];

// Podcast Section

export const podcastsPlatforms = [SpotifyPodcast, ApplePodcast, GooglePodcast];

export const podcastsArray = [tramyPodcast];

// Chat Bot

export const welcomeMessage =
  "¡Hola! Bienvenido a Tramy, el aliado ideal para los equipos que atienden y venden por WhatsApp. ¿Tienes alguna consulta? Contáctate con nuestro equipo de Customer Success 👇";
